import { defineMessages } from '@jutro/locale';

export default defineMessages({
    initiator: {
        id: 'ml.gateway.views.ActivityReports.mlQuotesAdditionalFilter.Initiator',
        defaultMessage: 'Initiator'
    },
    allInitiators: {
        id: 'ml.gateway.views.ActivityReports.mlQuotesAdditionalFilter.All Initiators',
        defaultMessage: 'All Initiators'
    },
    bundle: {
        id: 'ml.gateway.views.ActivityReports.mlQuotesAdditionalFilter.Bundle?',
        defaultMessage: 'Bundle?'
    },
    consumer: {
        id: 'ml.gateway.views.ActivityReports.mlQuotesAdditionalFilter.Consumer',
        defaultMessage: 'Consumer'
    },
    agent: {
        id: 'ml.gateway.views.ActivityReports.mlQuotesAdditionalFilter.Agent',
        defaultMessage: 'Agent'
    },
    compRater: {
        id: 'ml.gateway.views.ActivityReports.mlQuotesAdditionalFilter.Comp Rater',
        defaultMessage: 'Comp Rater'
    },
    bookRoll: {
        id: 'ml.gateway.views.ActivityReports.mlQuotesAdditionalFilter.Book Roll?',
        defaultMessage: 'Book Roll'
    }
});
